import { useEffect } from 'react';
import { TipoEventoQuadro } from '@nexital/shared';
import { useDependencias } from '../../application/dependencias';

/** Vários eventos seguidos (ex.: um grupo que cresce e empurra vizinhos) viram uma releitura só. */
const ESPERA_RELEITURA_MS = 150;
/** Arraste de colega sem movimento por mais que isso é descartado. */
const ARRASTE_PARADO_MS = 3000;

/**
 * Liga o quadro ao tempo real (ADR-0008): entra na sala, relê quando outra pessoa grava (RQ-COL-001), guarda
 * presença, arrastes e travas (RQ-COL-002 a RQ-COL-004) e, ao reconectar, reenvia o que foi feito offline e
 * relê o que foi perdido (RQ-COL-006).
 */
export function useTempoReal() {
  const { canal, storeQuadro, storeColaboracao, storeNotas, storeNotificacoes, sessao } = useDependencias();

  useEffect(() => {
    const colaboracao = () => storeColaboracao.getState();
    let espera: number | undefined;
    let esperaNotas: number | undefined;
    const reler = () => {
      window.clearTimeout(espera);
      espera = window.setTimeout(() => storeQuadro.getState().recarregar(), ESPERA_RELEITURA_MS);
    };
    const relerNotas = () => {
      window.clearTimeout(esperaNotas);
      esperaNotas = window.setTimeout(() => void storeNotas.getState().carregar(), ESPERA_RELEITURA_MS);
    };

    const sair = canal.entrar(sessao.quadroUuid, {
      aoConectar: (resposta) => {
        colaboracao().definirOnline(resposta.ok);
        if (!resposta.ok) return;
        resposta.eventos.forEach(colaboracao().receberEvento);
        void storeQuadro.getState().reenviarPendentes();
        reler();
        relerNotas();
        // Avisos gravados enquanto a conexão esteve fora (ex.: reinício do servidor) não chegam pela sala pessoal.
        void storeNotificacoes.getState().carregar();
      },
      aoDesconectar: () => colaboracao().definirOnline(false),
      aoEvento: (evento) => {
        if (evento.usuarioUuid) colaboracao().limparArrastesDe(evento.usuarioUuid);
        colaboracao().receberEvento(evento);
        const daNota = evento.tipo === TipoEventoQuadro.Nota || evento.tipo === TipoEventoQuadro.Conector;
        if (daNota) relerNotas();
        else reler();
      },
      aoPresenca: (pessoas) => colaboracao().definirPresenca(pessoas),
      aoArraste: (arraste) => colaboracao().receberArraste(arraste),
      aoTravas: (travas) => colaboracao().definirTravas(travas),
      aoNotificacao: (n) => storeNotificacoes.getState().receber(n),
    });
    const limpeza = window.setInterval(() => colaboracao().limparArrastesParados(Date.now(), ARRASTE_PARADO_MS), 1000);
    return () => {
      window.clearInterval(limpeza);
      window.clearTimeout(espera);
      window.clearTimeout(esperaNotas);
      sair();
    };
  }, [canal, storeQuadro, storeColaboracao, storeNotas, storeNotificacoes, sessao.quadroUuid]);
}
